import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MG',
  quote: 'Sentía muchísima inseguridad cuando empecé a atender. El módulo de entrevistas y evaluación me dio mucha más claridad para intervenir.',
  name: 'Mariana G.',
  location: 'Córdoba'
}, {
  initials: 'LP',
  quote: 'Lo que más me ayudó fue tener estructuras concretas para informes, entrevistas y organización clínica. Todo está explicado de forma clara y práctica.',
  name: 'Lucía P.',
  location: 'Rosario'
}, {
  initials: 'RM',
  quote: 'El kit de herramientas profesionales me ahorra muchísimo tiempo. Hoy trabajo con más seguridad y menos ansiedad.',
  name: 'Romina M.',
  location: 'Buenos Aires'
}];
export function SocialProofSection() {
  return <section className="py-16 bg-white/50" data-id="element-226">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-227">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-228">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 flex flex-col h-full" data-id="element-229">
              <div className="flex text-yellow-400 mb-4" data-id="element-230">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-231" />)}
              </div>
              <p className="text-slate-700 italic mb-6 flex-grow" data-id="element-232">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3" data-id="element-233">
                <div className="w-10 h-10 rounded-full bg-violet-100 text-violet-700 font-bold flex items-center justify-center text-sm" data-id="element-234">
                  {t.initials}
                </div>
                <div data-id="element-235">
                  <div className="font-semibold text-navy-900 text-sm" data-id="element-236">
                    {t.name}
                  </div>
                  <div className="text-xs text-slate-500" data-id="element-237">{t.location}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}